import {createContext, type ReactNode, useContext, useState} from "react";
import {getBrowserTimeZone} from "@/functions/timeZone.ts";
import {useCitiesStorage} from "@/hooks/useCitiesStorage.ts";
import {KEY} from "@/hooks/useCurrentCity.tsx";

interface TimeZoneContextType {
    timeZone: string
    changeTimeZone: (tz: string) => void
}

export const TimeZoneContext = createContext<TimeZoneContextType | null>(null)

/**
 * Hook personnalisé useTimeZone pour consommer le contexte.
 * Lance une erreur si utilisée en dehors du Provider afin d'éviter des accès indéfinis.
 */
export function useTimeZone() {
    const timeZoneContext = useContext(TimeZoneContext)
    if (!timeZoneContext) throw new Error("Timezone context is not defined")
    return timeZoneContext
}

export function TimeZoneProvider({ children }: { children: ReactNode }) {
    const { get } = useCitiesStorage(KEY)
    const registeredCity = get()
    const [timeZone, setTimeZone] = useState(registeredCity ? registeredCity[registeredCity.length - 1].timeZone : getBrowserTimeZone())
    const changeTimeZone = (timeZone: string) => {
        setTimeZone(timeZone)
    }

    return <TimeZoneContext.Provider value={{
        timeZone,
        changeTimeZone
    }}>
        {children}
    </TimeZoneContext.Provider>
}